import { useEffect } from "react";
import ErrorImage from "../../../assets/img/OfflineImage.png";

const ErrorOffline = () => {
  useEffect(() => {
    const goBackOnline = () => {
      const savedPath = sessionStorage.getItem("intendedPath") || "#/";
      setTimeout(() => {
        window.location.href = savedPath;
        sessionStorage.removeItem("intendedPath");
      }, 1000);
    };
    if (navigator.onLine) {
      goBackOnline();
    }

    window.addEventListener("online", goBackOnline);

    return () => window.removeEventListener("online", goBackOnline);
  }, []);

  const handleRetry = () => {
    if (navigator.onLine) {
      const savedPath = sessionStorage.getItem("intendedPath") || "#/";
      window.location.href = savedPath;
      sessionStorage.removeItem("intendedPath");
    } else {
      alert("Still offline! Please check your connection.");
    }
  };

  return (
     <div className="d-flex justify-content-center align-items-center vh-100 bg-white p-3">
      <div className="text-center">
        <h5
          className="fw-bold mb-4"
          style={{
            fontSize: "clamp(24px, 5vw, 44px)",
            fontWeight: 700,
          }}
        >
          You're offline!
        </h5>
        <p
          style={{
            fontSize: "clamp(16px, 3vw, 24px)",
            lineHeight: 1.5,
          }}
        >
          Please check your internet connection and try again.
        </p>
        <img
          src={ErrorImage}
          alt="Offline Illustration"
          className="img-fluid"
          style={{
            maxWidth: "100%",
            width: "clamp(200px, 50vw, 500px)",
            height: "auto",
          }}
        />
        <div>
        <button className="btn btn-primary" onClick={handleRetry}>
          Retry Now
        </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorOffline;
